export default __webpack_public_path__ + "images/logoKubraKay.508e7dbb81dae0b8c138ca715ce1d92b.svg"